import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

type ThisApi = ApiDefinition['/questionnaire-templates/field-templates/{fieldTemplateId}/pdf-fills']['PUT'];
type Input = ThisApi['params'] & ThisApi['body'];

const updatePdfFillsForFieldTemplate = async ({
  fieldTemplateId,
  pdfFills,
  listFieldTemplateId,
}: Input): Promise<ThisApi['response']> => {
  const data = await formsBackendClient.put(`/questionnaire-templates/field-templates/${fieldTemplateId}/pdf-fills`, {
    listFieldTemplateId,
    pdfFills,
  });
  return data.data;
};

export default updatePdfFillsForFieldTemplate;
